export enum FundsRequestStatus {
  New = 'new',
  WaitingTransaction = 'waiting_transaction',
  Completed = 'completed',
  Cancelled = 'cancelled',
  Revoked = 'revoked',
}
